import {
  Blockquote,
  List,
  Modal,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import {
  ModalAProps,
  ModalBProps,
  ModalCProps,
  ModalDProps,
} from "@/types/ModalTypes";
import { FC } from "react";
import { Text } from "@/components/Generics/Text";
import { useHomePageContext } from "@/hooks/contextHooks/useHomePageContext";
import { DatePickerInput } from "@mantine/dates";
import { getModalStyles } from "@/helpers/getModalStyles";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";
import styles from "../../css/buttons.module.css";

export const ModalA: FC<ModalAProps> = ({
  isOpen,
  onClose,
  title,
  message,
  btn1Title,
  btn2Title,
  btn1Action,
  btn2Action,
}) => {
  const { colors, isDarkMode } = useAppColors();
  const modalStyles = getModalStyles(isDarkMode, colors);
  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose(false)}
      title={title}
      styles={modalStyles}
    >
      <Blockquote color="red">
        <Text>{message}</Text>
      </Blockquote>
      <div className={styles.btnContainer}>
        <button
          onClick={btn1Action}
          className={styles.button}
          style={{ backgroundColor: colors.darkGray, color: colors.primary }}
        >
          {btn1Title}
        </button>
        <button
          onClick={btn2Action}
          className={styles.button}
          style={{ backgroundColor: colors.brand, color: colors.primary }}
        >
          {btn2Title}
        </button>
      </div>
    </Modal>
  );
};

export const ModalB: FC<ModalBProps> = ({
  isOpen,
  onClose,
  title,
  input1Name,
  input1Value,
  setInput1Value,
  input2Name,
  input2Value,
  setInput2Value,
  datePickerPlaceholder,
  datePickerValue,
  setDatePickerValue,
  datePickerLabel,
  btn1Title,
  btn2Title,
  btn1Action,
  btn2Action,
}) => {
  const { colors, isDarkMode } = useAppColors();

  const modalStyles = getModalStyles(isDarkMode, colors);

  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose(false)}
      title={title}
      styles={modalStyles}
    >
      <TextInput
        label={input1Name}
        value={input1Value}
        onChange={(e) => setInput1Value(e.currentTarget.value)}
        required
        styles={{
          label: modalStyles.label,
          input: modalStyles.input,
        }}
      />
      {/*
      <TextInput
        label={input2Name}
        value={input2Value}
        onChange={(e) => setInput2Value(e.currentTarget.value)}
        mt="md"
        styles={{ label: modalStyles.label, input: modalStyles.input }}
      />
      */}
      <Textarea
        label={input2Name}
        value={input2Value}
        onChange={(e) => setInput2Value(e.currentTarget.value)}
        mt="md"
        autosize
        minRows={3}
        maxLength={250}
        styles={{
          label: modalStyles.label,
          input: modalStyles.input,
        }}
      />

      <DatePickerInput
        value={datePickerValue}
        onChange={setDatePickerValue}
        mt="md"
        label={datePickerLabel}
        placeholder={datePickerPlaceholder}
        styles={{
          label: modalStyles.label,
          placeholder: modalStyles.placeholder,
          input: modalStyles.input,
        }}
      />
      <div className={styles.btnContainer}>
        <button
          onClick={btn1Action}
          className={styles.button}
          style={{ backgroundColor: colors.darkGray, color: colors.primary }}
        >
          {btn1Title}
        </button>
        <button
          onClick={btn2Action}
          className={styles.button}
          style={{ backgroundColor: colors.brand, color: colors.primary }}
        >
          {btn2Title}
        </button>
      </div>
    </Modal>
  );
};

export const ModalC: FC<ModalCProps> = ({
  isOpen,
  onClose,
  title,
  selectLabel,
  selectPlaceholder,
  selectValue,
  setSelectValue,
  btnLabel,
  btnOnClick,
}) => {
  const { projects } = useHomePageContext();
  const { colors, isDarkMode } = useAppColors();
  const modalStyles = getModalStyles(isDarkMode, colors);

  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose(false)}
      title={title}
      styles={modalStyles}
    >
      <Select
        label={selectLabel}
        placeholder={selectPlaceholder}
        data={projects.map((project) => ({
          value: project.id,
          label: project.name,
        }))}
        value={selectValue}
        onChange={setSelectValue}
        required
        styles={{
          label: modalStyles.label,
          input: modalStyles.input,
        }}
      />
      <div className={styles.btnContainer}>
        <button
          onClick={btnOnClick}
          className={styles.button}
          style={{ backgroundColor: colors.brand, color: colors.primary }}
        >
          {btnLabel}
        </button>
      </div>
    </Modal>
  );
};

export const ModalD: FC<ModalDProps> = ({
  isOpen,
  onClose,
  title,
  associatedStudies,
  btnOnClick,
}) => {
  const { colors, isDarkMode } = useAppColors();
  const modalStyles = getModalStyles(isDarkMode, colors);
  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose(false)}
      title={title}
      styles={{ title: modalStyles.title }}
    >
      <Blockquote color="red">
        <Text>This ship cannot be deleted because it is used in a study.</Text>
      </Blockquote>
      {/*
      <List mt="md">
        {associatedStudies.map((study) => (
          <List.Item key={study.id}>
            <Text size="medium">{study.experiment_name}</Text>
          </List.Item>
        ))}
      </List>
      */}
      <div className={styles.btnContainer}>
        <button
          onClick={() => btnOnClick(false)}
          className={styles.button}
          style={{ backgroundColor: colors.brand, color: colors.primary }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};
